import {IntermediatePart} from "../../intermediatePart";
import store from "../../../../../store";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class Oven extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'oven';
    this.partName = 'Oven';
    this.translateId = "visualizer.kitchen.appliance.oven";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Oven());
  }

  handleClick(ignoreLocked = false, clickFrom = "") {
    const {isEncore} = store.getState().fabricatorState;
    if (isEncore) {
      const featureIsLocked = getFeatureIsLocked(this, ignoreLocked);
      if (ignoreLocked || !featureIsLocked) {
        const applianceParent = this.getParent().getParent();
        if (applianceParent.layout.type === 6) {
          if (applianceParent.stovetop && applianceParent.stovetop.disabled) {
            applianceParent.stovetop.disabled = false;
          }
          if (applianceParent.hood && applianceParent.hood.disabled) {
            applianceParent.hood.disabled = false;
          }
          if (applianceParent.range && !applianceParent.range.disabled) {
            applianceParent.range.disabled = true;
          }
          if (applianceParent.microwave && !applianceParent.microwave.disabled) {
            applianceParent.microwave.disabled = true;
          }
        }
      }
    }
    return super.handleClick(ignoreLocked, clickFrom);
  }

  hideLayerCondition() {
    const applianceParent = this.getParent();
    // on the second layout we should show Oven only if stove has Metadata "T" (top)
    return (applianceParent.layout.type === 2) && applianceParent && applianceParent.stove && applianceParent.stove.activeFeature
      && applianceParent.stove.activeFeature && (!applianceParent.stove.activeFeature.metaData["Stove Type"]
        || (applianceParent.stove.activeFeature.metaData["Stove Type"][0] !== "T"))
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    if (this.hideLayerCondition()) {
      conditions.push({
        propName: "Stove Type",
        propValue: "F"
      });
    }
    return conditions
  }

}
